import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Tooltip, Button, Icon } from 'antd';
import { serviceFields } from '../../const/simbix';
import Label from '../widgets/Label';
/** Отображение списка значений для карточки FOAF
 * Формируется таблица, содержащая столбец с названием поля и столбец со значением поля
 * Для отображения поля используются специальные компоненты. Виды компонент описаны в widgets.
 * Получает список 
 */
const sortedStartPart = ['rdf_about', 'dcterms_language']
const sortedFinishPart = ['owl_versionInfo', 'csi_prefix']
const exclude = ['NName', 'rdf_type'];

const isEmpty = (value) => {
    if ((value == undefined) || (value == null)) return true;
    if (Array.isArray(value) && value.length==0) return true;
    if (value === "") return true;
    return false;
}
//Фильтрует полученные свойства для отображения. Исключает служебные свойства, свойства с пустыми значениями
//predicates содержит все предикаты, имеющие значения
const filterForShow = (predicates, values) => {
    if (predicates) return predicates;
    //Исключаем служебные элементы
    const first = Object.keys(record).filter(key => !serviceFields.includes(key)); 
    //Исключаем пустые поля
    const second = first.filter(key => !(isEmpty(record[key])));
    //Исключаем свойства, которые не должны показываться
    const properties = second.filter(key => !exclude.includes(key));
    //Формируем последовательность свойств для отображения
    console.log(properties)
    return properties.sort ((a, b) => {
            //console.log("0", a, b);
            //Начало списка свойств
            let indexA = sortedStartPart.indexOf(a);
            let indexB = sortedStartPart.indexOf(b);
            //console.log("1", indexA, indexB);
            if (indexA>-1){
                if (indexB>-1) return indexA-indexB;
                return -1;
            };
            if (indexB>-1) return 1;
            //конец списка свойств
            indexA = sortedFinishPart.indexOf(a);
            indexB = sortedFinishPart.indexOf(b);
            //console.log("2", indexA, indexB);
            if (indexA>-1){
                if (indexB < 0) return 1;
                return indexA-indexB;
            };
            if (indexB>-1) return 1;
            return 0;
        });
}
//Отображение Меток на английском языке
const EnLabel = ({props}) =>{
    return <span>&nbsp;(<Label {...props} lang="en"/>)</span>
}
class AssetLabel extends React.Component {

  render() {
    const {lang} = this.props;
        //<div className="csi_field_div">!!!</div>
        //  <Label {...this.props} />{(lang!="en")&& <EnLabel props={this.props}/>}
    return(
      <div className="csi_field_div">
        <Tooltip placement="left" title={this.props.iri}>
          <Label {...this.props} />
        </Tooltip>
      </div>
    )
  }
}
class AssetLabel2 extends React.Component {
  render() {
    const {graph, iri, lang} = this.props;
    return(
      <div className="csi_field_div">{iri}</div>
    )
  }
}


/** Для отображения значения поля. Для отображения необходимо указать:
 * 1. Предикат, содержащий данные
 * 2. Массив данных из которых их брать
 * 3. Язык
 * 4. Фабрика, которая возвращает компоненту для создания
 */
const FieldViewProxy = ({predicat, values, lang, factory, action}) =>{
    //console.log("FieldViewProxy", predicat, lang, factory, factory.ui);
    const Component = factory.ui.getUIComponent(predicat);
    //console.log("FieldViewProxy2", Component);
    return (
        <div className="csi_value_div">
          <Component lang={lang} uri={predicat} values={values} factory={factory} action={action}/>
        </div>
    )
}

const { confirm } = Modal;
/** Базовая компонента отображения свойств
 */
class DetailLinkCard extends React.Component {
    state = {
        selected: undefined,    //Свойство (predicat), которое редактируется, удаляется или для него осуществляется перерво
        operation: "view",      //Текущая операция. Может быть view, edit, translate, delete
    }

    render(){
        console.log(this); 
        const {predicates, values, lang, factory, IRI} = this.props;
        const properties = filterForShow(predicates, values);
        const FieldProxy = FieldViewProxy;
        return (
            <span>
            <Row className="assetCardTable_tr"> 
              <Col span={10} className="assetCardTable_td"><div className="csi_field_div">IRI</div></Col>
              <Col span={14} className="assetCardTable_td"><div className="csi_value_div">{IRI}</div></Col>
            </Row>
                {properties.map((prop, i) => 
          <Row key={i} className="assetCardTable_tr"> 
					<Col span={10} className="assetCardTable_td">
						<AssetLabel iri={prop} />
					</Col>
					<Col span={14} className="assetCardTable_td" style={{display: "block"}}>
						<FieldProxy 
							factory={factory} lang={lang} predicat={prop} values={values}
							{...this.state} 
							action={(e, type, predicat)=> this.onAction(e, type, predicat)}/>
					</Col>
				</Row>
					)}
      </span>
        )
        }
}

const TopRow = () => 
    <tr className="top-row">
        <td className="top-left-corner"></td>
        <td className="top-middle"></td>
        <td className="top-right-corner"></td>
    </tr>
const BottomRow = () =>
    <tr className="bottom-row">
        <td className="bottom-left-corner"></td>
        <td className="bottom-middle"></td>
        <td className="bottom-right-corner"></td>
    </tr>

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vasset, vset } = state;
    const {lang, triplet} = props;
    const items = vasset.values.filter(item => (item.object.value == triplet.object.value)&&(item.predicat.value == triplet.predicat.value));
    const values = (items && Array.isArray(items) && items.length>0)? items[0].values: null;
    const predicates = (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[];
    return {
      lang: (lang)?lang: vset.lang,
      predicates,
      values,
    };
}
export default connect(mapStateToProps)(DetailLinkCard);